import { defineStore } from 'pinia'

import type { MasteryMapDashboardStore } from './interfaces'

import { actions } from './actions'
import { getters } from './getters'

export const useMasteryMapDashboardStore = defineStore('mastery-map-dashboard', {
  state: (): MasteryMapDashboardStore => ({
    dashboardById: {},
    viewById: {},
  }),
  actions,
  getters,
})
